import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class NominalCodeReferenceService extends BaseReferenceService {
  constructor() {
    super('NominalCodeReference');
  }
}
